























import { Vue, Prop, Component } from 'vue-property-decorator'
import BasePanel1 from './BasePanel1.vue'
@Component({
  name: 'MiniTable2',
  components: { BasePanel1 }
})
export default class extends Vue {
  @Prop({ required: true }) private mainData: any

  get itemWidth() {
    return (100 / this.mainData.valueDescs.length) + '%'
  }
}
